// extracted by mini-css-extract-plugin
export default {"label":"Label-module_label__JL9B3","text":"Label-module_text__A2HUc","hint":"Label-module_hint__TDAcb"};